module.exports = __webpack_public_path__ + "img/inm_logo.3190ee95.png";